import axiosApiConfig from '@/axiosApiConfig';

interface ICurrencyExchange {
  date: string;
  exchangeRate: number;
}

const getCurrencyExchangeRates = async (): Promise<ICurrencyExchange> => {
  const result= await axiosApiConfig.get('/currency_exchanges');
  return result.data;
};

export default getCurrencyExchangeRates;
